import { css } from "@emotion/react";

import { dimensions } from "@styles";

export const form = css`
  display: grid;
  gap: 2rem;
`;

export const blurb = css`
  text-align: center;
  padding-inline: 1rem;
  max-width: 30rem;
  margin: auto;
`;

export const personalInfo = css`
  margin-top: -1rem;
`;

export const buttonWrapper = css`
  display: flex;
  justify-content: space-between;
`;

export const goBack = css`
  @media (max-width: ${dimensions.phoneLarge}) {
    display: none;
  }
`;

export const proceedButtons = css`
  margin-left: auto;

  @media (max-width: ${dimensions.phoneLarge}) {
    width: 100%;
  }
`;

export const button = css`
  &:first-of-type {
    margin-right: 0.5rem;
  }

  @media (max-width: ${dimensions.phoneLarge}) {
    width: 100%;

    &:first-of-type {
      margin-bottom: 0.5rem;
      margin-right: 0;
    }
  }
`;
